import React from "react";
import { EntityRegistry } from "../EntityRelationsManager";
import "./_entity-relation-validation.scss";

interface EntityValidationProgressProps {
  entityTypes: string[];
  currentEntityIndex: number;
  processedEntities: Record<string, any[]>;
  entityRegistry: EntityRegistry;
}

export const EntityValidationProgress: React.FC<EntityValidationProgressProps> = ({
  entityTypes,
  currentEntityIndex,
  processedEntities,
  entityRegistry
}) => {
  const totalEntities = entityTypes.length;
  const completedEntities = Object.keys(processedEntities).length;
  const progressPercent = totalEntities > 0 ? (completedEntities / totalEntities) * 100 : 0;

  return (
    <div className="progress-container">
      <div className="progress-steps">
        <div className="progress-bar" style={{ width: `${progressPercent}%` }} />

        {entityTypes.map((entityType, index) => {
          const isProcessed = !!processedEntities[entityType];
          const isActive = index === currentEntityIndex;
          const isDisabled = index > currentEntityIndex;
          const entityName = entityRegistry[entityType]?.metadata.displayName || entityType;

          return (
            <div key={index} className="progress-step">
              <div
                className={`step-indicator ${isActive ? "active" : ""} ${isProcessed ? "completed" : ""} ${
                  isDisabled ? "disabled" : ""
                }`}
              >
                {!isProcessed && index + 1}
              </div>
              <div className={`step-label ${isActive ? "active" : ""}`}>{entityName}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
